import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { useStore } from 'hooks';
import { Button, ButtonClose } from 'components/ui/form';
import { Select } from 'components/ui/formik';
import { UserConsigneeService, ConsigneeService } from 'services';
import styles from './consignee.module.scss';

const Consignee = ({ onClose }) => {
  const { setUser, setLoading } = useStore();
  const [consignees, setConsignees] = useState([]);

  useEffect(() => {
    (async () => {
      setLoading(true);

      const response = await new ConsigneeService({ setUser }).getConsignees({ limit: 'max' });
      if (response) {
        setConsignees(response.items);
      }

      setLoading(false);
    })();
  }, [setUser, setLoading]);

  const initialValues = {
    consigneeId: consignees.length ? consignees[0].id : '',
  };

  const onSubmit = async (values) => {
    setLoading(true);
    await new UserConsigneeService({ setUser }).createConsignee({ ...values });
    setLoading(false);
    onClose(true);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ handleSubmit }) => (
          <form onSubmit={handleSubmit} className={styles.consignee} autoComplete="off">
            <div className={styles.main}>
              <div className={styles.title}>Добавление грузополучателя</div>
              <div className={styles.fields}>
                <div className={styles.field}>
                  <Select label="Грузополучатель" name="consigneeId">
                    {consignees.map(({ id, name }) => (
                      <option key={id} value={id}>{name}</option>
                    ))}
                  </Select>
                </div>
              </div>
            </div>
            <div className={styles.buttons}>
              <div>
                <Button type="submit">Добавить</Button>
              </div>
              <div>
                <ButtonClose onClick={() => onClose(false)}>Отменить</ButtonClose>
              </div>
            </div>
          </form>
      )}
    </Formik>
  );
};

export default Consignee;
